import { Box, useTheme } from "@mui/material";
import Header from "../../components/Header";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";

const FAQ = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header title="FAQ" subtitle="Frequently Asked Questions Page" />

      <Accordion
        defaultExpanded
        sx={{
          mb: "10px",
          backgroundColor: colors.primary[400],
          borderRadius: "8px",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            How do I place an order?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            To place an order, browse through our product catalog, select the items you wish to purchase, and add them to your cart. Once you have all your desired items in the cart, proceed to checkout to complete your purchase.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        defaultExpanded
        sx={{
          mb: "10px",
          backgroundColor: colors.primary[400],
          borderRadius: "8px",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            What payment methods do you accept?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            We accept various payment methods including credit cards (Visa, MasterCard, American Express), PayPal, and bank transfers.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        defaultExpanded
        sx={{
          mb: "10px",
          backgroundColor: colors.primary[400],
          borderRadius: "8px",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            How can I track my order?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            After placing your order, you will receive an email with a tracking number and a link to track your order status. You can also log in to your account on our website to view your order history and tracking information.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        defaultExpanded
        sx={{
          mb: "10px",
          backgroundColor: colors.primary[400],
          borderRadius: "8px",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            What is your return policy?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            We offer a 30-day return policy on most items. If you are not satisfied with your purchase, you can return it within 30 days of receipt for a full refund or exchange. Please ensure the item is in its original condition and packaging.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        defaultExpanded
        sx={{
          mb: "10px",
          backgroundColor: colors.primary[400],
          borderRadius: "8px",
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography color={colors.greenAccent[500]} variant="h5">
            Do you offer customer support?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            Yes, we offer customer support via email, phone, and live chat. Our support team is available from Monday to Friday, 9 AM to 6 PM. You can also visit our Help Center for FAQs and troubleshooting guides.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default FAQ;
